module.exports = __webpack_public_path__ + "img/HZ-S4028.4d225bfe.jpg";